import {
  CheckmarkOutline,
  Error,
  Pending,
  WarningAlt,
  WarningHex,
} from '@carbon/react/icons';
import { Button } from '@carbon/react';
import React from 'react';
import styles from './validity-status-indicator.module.scss';

export interface ValidityStatusIndicatorProps {
  status: string;
}

export interface ValidityStatusConfig {
  icon: React.ReactElement | null;
  tooltip: string | null;
}

export const useValidityStatusConfig = (
  status: string | null
): ValidityStatusConfig => {
  const getStatusConfig = (status: string | null): ValidityStatusConfig => {
    switch (status) {
      case 'valid':
      case 'success':
        return {
          icon: <CheckmarkOutline className={styles.validIcon} />,
          tooltip: 'Valid',
        };
      case 'warning':
        return {
          icon: <WarningAlt className={styles.warningIcon} />,
          tooltip: 'Warning',
        };
      case 'incomplete':
        return {
          icon: <Pending className={styles.incompleteIcon} />,
          tooltip: 'Incomplete',
        };
      case 'invalid':
      case 'flagged':
        return {
          icon: <WarningHex className={styles.invalidIcon} />,
          tooltip: 'Invalid',
        };
      case 'error':
        return {
          icon: <Error className={styles.errorIcon} />,
          tooltip: 'Error',
        };
      default:
        return {
          icon: null,
          tooltip: 'Unknown status',
        };
    }
  };

  return getStatusConfig(status);
};

export const ValidityStatusIndicator: React.FC<
  ValidityStatusIndicatorProps
> = ({ status }) => {
  const config = useValidityStatusConfig(status);

  return (
    <Button
      kind="ghost"
      size="sm"
      hasIconOnly
      renderIcon={() => config.icon}
      iconDescription={config.tooltip ?? undefined}
    />
  );
};

export default ValidityStatusIndicator;
